import * as React from 'react';
import type { SVGProps } from 'react';
const SvgDirectRight = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={25} height={25} fill='none' {...props}>
    <path
      stroke='currentColor'
      strokeLinecap='round'
      strokeLinejoin='round'
      strokeWidth={1.5}
      d='M19.54 9.67 7.95 3.57C5.2 2.12 2.21 5.05 3.6 7.83l1.62 3.24c.45.9.45 1.96 0 2.86L3.6 17.17c-1.39 2.78 1.6 5.7 4.35 4.26l11.59-6.1c2.28-1.2 2.28-4.46 0-5.66'
    />
  </svg>
);
export default SvgDirectRight;
